module.exports = __webpack_public_path__ + "media/gb.798639b5.mp4";